<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path
    d="M6.5 2.4C6.5 1.96 6.88 1.72 7.26 1.94L14.86 7.34C15.18 7.52 15.18 8.48 14.86 8.66L7.26 14.06C6.88 14.28 6.5 14.04 6.5 13.6V2.4Z"
    fill="black"></path>
</svg>